import { Logger } from '@nvision/services/logger';

export const logger = new Logger({ prefix: 'settings' });
